import { currency } from '@mooveguru/js-utilities';
import genericAddresses from '../config/local/generic-addresses';
import genericNames from '../config/local/generic-names';
import formatPhoneNumberForDisplay from './formatPhoneNumberForDisplay';

/** @returns {string} */
export function address() {
	const randomIndex = Math.floor(Math.random() * genericAddresses.length);
	const randAdd = genericAddresses[randomIndex];
	return `${randAdd.streetAddress}, ${randAdd.city}`;
}

/**
 * @param {number} [min]
 * @param {number} [max]
 * @returns {number}
 */
export function randNumRange(min = 1, max = 100) {
	return Math.floor(Math.random() * ((max - min + 1) + min)); // prettier-ignore
}

/**
 * @param {number} [min]
 * @param {number} [max]
 * @returns {string}
 */
export function priceRange(min = 1, max = 100) {
	const minInCents = min * 100;
	const maxInCents = max * 100;

	return currency.convertNumberToCurrencyString(
		currency.convertCentsToDollars(randNumRange(minInCents, maxInCents))
	);
}

/** @returns {string} */
export function name() {
	const randomIndex = Math.floor(Math.random() * genericNames.length);
	return genericNames[randomIndex];
}

/** @returns {string} */
export function email() {
	return `${name().replace(/\s/g, '.').toLowerCase()}@gmail.com`;
}

/** @returns {string} */
export function phone() {
	const min = 1000000000;
	const max = 9999999999;
	return formatPhoneNumberForDisplay(
		`${Math.floor(Math.random() * ((max - min + 1) + min))}` // prettier-ignore
	);
}
